import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../assets/images/80eight/88-footer-white.svg";
import Toaster from "./ui/toaster";
import bgVideo from "../assets/images/loader.mp4";

export default function CardSpinningLoader({ logoTopposition = "top-[80%]" }) {
  return (
    <AnimatePresence>
      <motion.div
        className="h-full w-full flex items-center justify-center dark:bg-black bg-white inset-0 z-50 blur"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4 }}
      >
        <div className="relative flex items-center justify-center lg:w-[70%] lg:h-[70%] w-full h-full scale-150 lg:scale-100">
          <video
            src={bgVideo}
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-contain"
          />
        </div>
      </motion.div>
      <motion.img
        src={logo}
        alt="Logo"
        className={`absolute z-[1000] ${logoTopposition} mx-auto w-full h-12`}
      />
      <Toaster />
    </AnimatePresence>
  );
}
